import React from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import CourseCurriculumsHeader from "./CourseDetailsHeader";
import AddToCartVerticalBlock from "./AddToCartVerticalBlock";
import CoursesListSlide from "./CoursesListSlide";

function CourseBundleDetails() {
  return (
    <>
      <div className='res-add-cart-block'>
        <AddToCartVerticalBlock />
      </div>
      <CourseCurriculumsHeader className="mb-4" />
      <Container>
        <Row>
          <div className='res-add-cart-detail-block'>
            <AddToCartVerticalBlock />
          </div>
          <Col lg={8}>
            <CoursesListSlide className="res-bundle-carousel" />
          </Col>
          <Col lg={4}>
            <div className='mobile-add-cart-block'>
              <AddToCartVerticalBlock />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CourseBundleDetails;
